"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentApi = exports.DocumentApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * DocumentApi - axios parameter creator
 * @export
 */
const DocumentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (documentId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('deleteDocument', 'documentId', documentId);
            const localVarPath = `/api/document/{document_id}/delete`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument: async (documentId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('downloadDocument', 'documentId', documentId);
            const localVarPath = `/api/document/{document_id}/content`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {DocumentCategory} [category]
         * @param {boolean} [includeInactive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocuments: async (category, includeInactive, options = {}) => {
            const localVarPath = `/api/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IDocumentReorder} iDocumentReorder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderDocuments: async (iDocumentReorder, options = {}) => {
            // verify required parameter 'iDocumentReorder' is not null or undefined
            (0, common_1.assertParamExists)('reorderDocuments', 'iDocumentReorder', iDocumentReorder);
            const localVarPath = `/api/document/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDocumentReorder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} documentId
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceDocument: async (documentId, file, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('replaceDocument', 'documentId', documentId);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('replaceDocument', 'file', file);
            const localVarPath = `/api/document/{document_id}/replace`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} documentId
         * @param {IDocumentUpdate} iDocumentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument: async (documentId, iDocumentUpdate, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            (0, common_1.assertParamExists)('updateDocument', 'documentId', documentId);
            // verify required parameter 'iDocumentUpdate' is not null or undefined
            (0, common_1.assertParamExists)('updateDocument', 'iDocumentUpdate', iDocumentUpdate);
            const localVarPath = `/api/document/{document_id}/update`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDocumentUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {any} file
         * @param {string} category
         * @param {string} [label]
         * @param {string} [language]
         * @param {string} [alwaysAttach]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument: async (file, category, label, language, alwaysAttach, options = {}) => {
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('uploadDocument', 'file', file);
            // verify required parameter 'category' is not null or undefined
            (0, common_1.assertParamExists)('uploadDocument', 'category', category);
            const localVarPath = `/api/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (category !== undefined) {
                localVarFormParams.append('category', category);
            }
            if (label !== undefined) {
                localVarFormParams.append('label', label);
            }
            if (language !== undefined) {
                localVarFormParams.append('language', language);
            }
            if (alwaysAttach !== undefined) {
                localVarFormParams.append('always_attach', alwaysAttach);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DocumentApiAxiosParamCreator = DocumentApiAxiosParamCreator;
/**
 * DocumentApi -
 */
var DocumentApi;
(function (DocumentApi) {
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof DocumentApi
     * url /api/document/{document_id}/delete
     */
    async function deleteDocument(documentId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(documentId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    DocumentApi.deleteDocument = deleteDocument;
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof DocumentApi
     * url /api/document/{document_id}/content
     */
    async function downloadDocument(documentId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocument(documentId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    DocumentApi.downloadDocument = downloadDocument;
    /**
     *
     * @param {DocumentCategory} [category]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof DocumentApi
     * url /api/document
     */
    async function listDocuments(category, includeInactive, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listDocuments(category, includeInactive, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseIDocumentEntity)(x));
            return res;
        });
    }
    DocumentApi.listDocuments = listDocuments;
    /**
     *
     * @param {IDocumentReorder} iDocumentReorder
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof DocumentApi
     * url /api/document/reorder
     */
    async function reorderDocuments(iDocumentReorder, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.reorderDocuments(iDocumentReorder, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseIDocumentEntity)(x));
            return res;
        });
    }
    DocumentApi.reorderDocuments = reorderDocuments;
    /**
     *
     * @param {number} documentId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof DocumentApi
     * url /api/document/{document_id}/replace
     */
    async function replaceDocument(documentId, file, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.replaceDocument(documentId, file, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIDocumentEntity)(res.data);
            return res;
        });
    }
    DocumentApi.replaceDocument = replaceDocument;
    /**
     *
     * @param {number} documentId
     * @param {IDocumentUpdate} iDocumentUpdate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof DocumentApi
     * url /api/document/{document_id}/update
     */
    async function updateDocument(documentId, iDocumentUpdate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocument(documentId, iDocumentUpdate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIDocumentEntity)(res.data);
            return res;
        });
    }
    DocumentApi.updateDocument = updateDocument;
    /**
     *
     * @param {any} file
     * @param {string} category
     * @param {string} [label]
     * @param {string} [language]
     * @param {string} [alwaysAttach]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof DocumentApi
     * url /api/document
     */
    async function uploadDocument(file, category, label, language, alwaysAttach, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.DocumentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocument(file, category, label, language, alwaysAttach, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIDocumentEntity)(res.data);
            return res;
        });
    }
    DocumentApi.uploadDocument = uploadDocument;
})(DocumentApi || (exports.DocumentApi = DocumentApi = {}));
